export const eo = {
    LEFT: 'Maldekstra: Moviĝu al la antaŭa tago.',
    RIGHT: 'Dekstra: Movi al la sekva tago.',
    DOWN: 'Malsupren: Movi al la sekva vico.',
    UP: 'Supre: Moviĝu al la antaŭa vico.',
    PGUP: 'Pĝsup: Moviĝu al la antaŭa monato.',
    PGDOWN: 'PgDown: Movi al la sekva monato.',
    HOME: 'Home: Moviĝu al la antaŭa jaro.',
    END: 'Fino: Movi al la sekva jaro.',
    ESC: 'Esk/Hodiaŭ/Egale: fermi la kalendaro.',
    TITLE: 'Klavaro Instrukcioj'
};
